import { useQuery } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/sales'
const QUERY_KEY = 'sales'

export const useGetSalesStats = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'stats', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/stats`, query))).data,
    config,
  )

export const useGetSalesIds = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'salesIds', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/salesIds`, query))).data,
    config,
  )
